export ControlPanel from './components/ControlPanel';


/** WEBPACK FOOTER **
 ** ./src/app/modules/controlPanel/index.js
 **/